@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

:host {
  a[data-link="sign in"], button[data-link="sign in"]{
    @include pigment-button-primary();
    cursor: pointer;
  }
  a[data-link="sign up"], button[data-link="sign up"]{
    @include pigment-button-secondary();
    background-color: $color-shade-white;
    cursor: pointer;
  }
  button[data-link="sign out"], a[data-link="sign out"]{
    background-color: $color-shade-white;
    font-family: $typography-family-sans;
    border: none;
    cursor: pointer;
    font-size: $typography-button-large-size;
    
    @include breakpoint('md','lg','xl') {
      font-size: $typography-button-medium-size;
    }
  }
  hr {
    display: block;
    border: 0;
    border-bottom: 1px solid $color-gray-accent;
    margin: 8px 0;
    width: 100%;
  }
  ci-dialog::part(content) {
    @include breakpoint('md','lg','xl') {
      padding: 8px 16px 16px 16px;
    }
  }
  ci-dialog::part(surface) {
    @include breakpoint('md','lg','xl') {
      width: 307px;
      align-items: stretch;
    }
  }
  .dialog-content {
    font-family: $typography-family-sans;
  }
  .dialog-actions{
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    width: 100%;
    gap: 8px;
    @include breakpoint('md','lg','xl') {
      font-size: 14px;
    }
  }
  .ciHeader-account-subMenu-subtitle {
    font-family: $typography-family-sans;
    font-weight: 400;
    font-size: 14px;
    box-sizing: border-box;
    line-height: normal;
  }
}

ci-dialog[is-logged-in]  {
  &::part(header) {
    @include breakpoint('md','lg','xl') {
      display: none;
    }
  }
  &::part(surface) {
    @include breakpoint('md','lg','xl') {
      padding: 8px 0;
    }
  }
  &::part(actions) {
    padding: 0;
  }
  &::part(content) {
    display: none;
    @include breakpoint('md','lg','xl') {
      display: none;
    }
  }
  .dialog-actions {
    gap: 0;
  }
  .dialog-action {
    margin: 0 24px;
    overflow: hidden;
    display: flex;
    height:2.25rem;
    align-items: center;
    border-radius: 0.25rem;
    line-height: 1.285;
    color: $color-gray-slate-default;
    text-decoration: none;
    &:link, &:visited {
      color: $color-gray-slate-default;
    }
    &:hover {
      color: $color-blue-default;
      background: $color-header-hover-blue;
      svg path {
        fill: $color-blue-default;
      }
    }
    &:focus {
      border-radius: 4px;
      border: 1px solid $color-blue-default;
    }
    svg {
      vertical-align: middle;
      display: inline-block;
      height: 17.93px;
      width: 16.25px;
      padding: 1.67px 2.5px 0.4px 1.25px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 0.5rem;
    }
    @include breakpoint('md','lg','xl') {
      margin: 0 0.5rem;
      padding: 0 0.5rem;
    }
    img {
      height: 1rem;
      width: auto;
    }
  }
}
